import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { useSelector } from 'react-redux';
import { getActiveLocaleSelector } from '@americanexpress/travel-selectors';

const PageMeta = ({ pageTitle }) => {
  const activeLocale = useSelector(getActiveLocaleSelector);

  return (
    <Helmet
      {...{
        htmlAttributes: {
          lang: activeLocale,
          'data-dls-surface': 'base',
        },
        link: [
          {
            rel: 'stylesheet',
            href: 'https://www.aexp-static.com/cdaas/dls/packages/@americanexpress/dls/7.14.0/stylesheets/dls-max.min.css',
          },
          { rel: 'icon', href: 'https://www.americanexpress.com/favicon.ico' },
          {
            rel: 'apple-touch-icon',
            sizes: '152x152',
            href: 'https://www.americanexpress.com/apple-touch-icon-152x152.png',
          },
        ],
        bodyAttributes: { class: 'color-surface-bg' },
        meta: [
          { 'http-equiv': 'X-UA-Compatible', content: 'IE=edge' },
          { charset: 'utf-8' },
          { name: 'viewport', content: 'width=device-width, initial-scale=1' },
          { name: 'application-name', content: 'American Express' },
          { name: 'keywords', content: 'one-amex' },
        ],
        title: pageTitle,
      }}
    />
  );
};

PageMeta.propTypes = {
  pageTitle: PropTypes.string.isRequired,
};

export default PageMeta;
